<template>
  <div class="receive-coupon">
    <img class="header-bg" src="@/assets/image/bjinformation2.png" alt="">
    <p class="title">停车场详情</p>
    <div class="parking-info">
      <div class="info-item">
        <span>停车场名</span><span class="cFF8200">测试停车场</span>
      </div>
      <div class="info-item">
        <span>车牌号</span><span class="cFF8200">测试停车场</span>
      </div>
      <div class="info-item">
        <span>入场时间</span><span class="c999999">测试停车场</span>
      </div>
      <div class="info-item">
        <span>停车时长</span><span class="c999999">测试停车场</span>
      </div>
      <div class="info-item">
        <span>停车费用</span><span class="c999999">测试停车场</span>
      </div>
    </div>
    <div class="parking-img">
      <span>入场图片</span>
      <img class="car-img" src="" alt="">
    </div>
    <van-button class="linear-gradient receive-btn" type="info" @click="getCoupon">
      领取优惠券
    </van-button>
  </div>
</template>

<script>
import { listCarRecord } from "@/utils/api"
import { Toast, Notify } from 'vant'

export default {
  name: 'ReceiveCoupon',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      merchantInfo: null,
      records: []
    }
  },
  computed: {},
  watch: {},
  created () {
    this.merchantInfo = JSON.parse(localStorage.getItem('merchantInfo'))
    const urlParam = this.$route.query


    // this.getCarList()
  },
  mounted () {},
  destroyed () {},
  methods: {
    getCarList () {
      let that = this

      let param = {
        carLicense: this.carlicense,
        uid: this.merchantInfo.uid,
        unitId: this.merchantInfo.unitId,
        token: this.merchantInfo.token,
      }
      listCarRecord(param)
      .then(result => {
        if (result.status == "200") {
          that.carlist = result.data
        }else {
          Notify({ type: "danger", message: result.message })
        }
      })
      .catch(err => {
        window.console.log(err);
      })
    }
  },
}
</script>

<style scoped lang="scss">
.receive-coupon{
  font-size: 24px;
  color: #333333;
  .header-bg{
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 280px;
    top: 0;
    left: 0;
  }
  .title{
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    margin: 70px 0 30px 30px;
    text-align: left;
  }
  .parking-info{
    width: 690px;
    height: 461px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 0px rgba(174, 185, 190, 0.7);
    border-radius: 10px;
    margin: 26px auto;
    padding: 8px 25px;
    box-sizing: border-box;
    .info-item{
      height: 88px;
      line-height: 88px;
      border-bottom: 1px solid #E5E5E5;
      display: flex;
      justify-content: space-between;
      padding: 0 20px 0 13px;
      box-sizing: border-box;
    }
    .c999999{color: #999999;}
    .cFF8200{color: #FF8200;}
  }
  .parking-img{
    width: 690px;
    height: 393px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 0px rgba(174, 185, 190, 0.7);
    border-radius: 10px;
    margin: 0 auto;
    margin-bottom: 80px;
    padding: 40px;
    box-sizing: border-box;
    text-align: left;
    .car-img{
      width: 606px;
      height: 262px;
      // border: 1px solid #C9C9C9;
      margin-top: 22px;
    }
  }
  .receive-btn{
    width: 600px;
    height: 80px;
    border-radius: 4px;
  }
}
</style>